jQuery(document).ready(function ($) {
  var $testimony = $(".box-carousel-testimony .swiper");

  if (!$testimony.length) return;

  $testimony.each(function (index, element) {
    var mySwiper = new Swiper(element, {
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      slidesPerView: 1,
      spaceBetween: 10,
      speed: 500,
      rewind: true,
      // centerInsufficientSlides: true,
      navigation: {
        nextEl: $(element).parent().find(".carousel-navigation .next")[0],
        prevEl: $(element).parent().find(".carousel-navigation .prev")[0],
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });
  });
});
